import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { APP_NAME } from "@crewledger/shared/constants";
import { useAuth } from "@/features/auth/auth-provider";
import { BetaPartialDashboardPage } from "@/features/beta-onboarding/beta-partial-dashboard-page";
import { useWorkspaceSetup } from "@/features/beta-onboarding/hooks/use-workspace-setup";
import { DashboardPage } from "./dashboard-page";

/**
 * Routes /dashboard by workspace type and beta setup progress.
 * Never mixes demo seed data into real beta/production accounts.
 */
export function DashboardRouterPage() {
  const { ready, provisioned, workspace } = useAuth();
  const { data: setup, loading: setupLoading, refresh: refreshSetup } = useWorkspaceSetup();

  useEffect(() => {
    document.title = `Dashboard — ${APP_NAME}`;
  }, []);

  if (!ready || !provisioned || !workspace) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (workspace.type === "DEMO") {
    return <Navigate to="/demo/dashboard" replace />;
  }

  if (workspace.type === "BETA") {
    if (setupLoading && !setup) {
      return (
        <div className="flex min-h-[40vh] items-center justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      );
    }

    if (!setup) {
      return <Navigate to="/dashboard/setup" replace />;
    }

    switch (setup.phase) {
      case "empty":
        return <Navigate to="/dashboard/setup" replace />;
      case "partial":
        return (
          <BetaPartialDashboardPage
            setup={setup}
            onRefreshSetup={() => void refreshSetup()}
            setupRefreshing={setupLoading}
          />
        );
      case "complete":
        return <DashboardPage />;
    }
  }

  return <DashboardPage />;
}
